export const WHEEL_RADIUS = 320;
export const TEXT_POS = 0.95;
